import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-416abb54")

_pushScopeId("data-v-416abb54")
const _hoisted_1 = { class: "card mb-10 p-5 orders-header-area" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6 d-flex flex-wrap align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-chart-bar icon-size" })
], -1)
const _hoisted_5 = { class: "order-setting" }
const _hoisted_6 = {
  key: 0,
  class: "m-0 tableOpacity"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("rect", {
  x: "26%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "23%",
  height: "16"
}, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "m-0",
  style: {"width":"max-content"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-color-default " }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_13 = { class: "col-md-6 d-flex flex-wrap align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-chart-line icon-size" })
], -1)
const _hoisted_15 = { class: "order-setting" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = {
  key: 0,
  class: "m-0 tableOpacity"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("rect", {
  x: "26%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "23%",
  height: "16"
}, null, -1)
const _hoisted_20 = {
  key: 1,
  class: "m-0",
  style: {"width":"max-content"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "text-color-default " }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_24 = { class: "card mb-10 p-5 orders-header-area" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-6 d-flex flex-wrap align-items-center" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-money-bill-alt icon-size" })
], -1)
const _hoisted_28 = { class: "order-setting" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = {
  key: 0,
  class: "m-0 tableOpacity"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("rect", {
  x: "26%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "23%",
  height: "16"
}, null, -1)
const _hoisted_33 = {
  key: 1,
  class: "m-0",
  style: {"width":"max-content"}
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "text-color-default " }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_37 = { class: "col-md-6 d-flex flex-wrap align-items-center" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-money-bill-wave icon-size" })
], -1)
const _hoisted_39 = { class: "order-setting" }
const _hoisted_40 = { class: "" }
const _hoisted_41 = {
  key: 0,
  class: "m-0 tableOpacity"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("rect", {
  x: "0",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "20%",
  height: "16"
}, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("rect", {
  x: "26%",
  y: "0",
  rx: ".25rem",
  ry: ".25rem",
  width: "23%",
  height: "16"
}, null, -1)
const _hoisted_44 = {
  key: 1,
  class: "m-0",
  style: {"width":"max-content"}
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "text-color-default " }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_48 = { class: "card main-orders-list" }
const _hoisted_49 = { class: "row card-p show-deleted-order-toggle" }
const _hoisted_50 = { class: "show-deleted-order-toggle-wrapper" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = {
  key: 2,
  class: "subscription-title"
}
const _hoisted_55 = { key: 3 }
const _hoisted_56 = {
  key: 4,
  class: "subscription-title"
}
const _hoisted_57 = {
  key: 0,
  class: "badge badge-light-danger"
}
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_61 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_62 = {
  key: 1,
  class: "badge badge-light-primary"
}
const _hoisted_63 = {
  key: 2,
  class: "badge badge-light-danger"
}
const _hoisted_64 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_66 = { class: "menu-item-wrapper" }
const _hoisted_67 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
const _hoisted_69 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ban" })
], -1)
const _hoisted_71 = {
  key: 2,
  class: "menu-item"
}
const _hoisted_72 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_AdvanceSearch = _resolveComponent("AdvanceSearch")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode("h4", null, _toDisplayString(`${_ctx.$t('message.TODAY_REVENUE')}`), 1),
            (_ctx.loader)
              ? (_openBlock(), _createBlock("p", _hoisted_6, [
                  _createVNode(_component_content_loader, {
                    width: "100%",
                    height: "16",
                    speed: 2,
                    primaryColor: "#ababab",
                    secondaryColor: "#cccccc"
                  }, {
                    default: _withId(() => [
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_9, [
                  (!_ctx.dashboard.today_revenue_millify)
                    ? (_openBlock(), _createBlock("span", _hoisted_10, [
                        _createTextVNode(_toDisplayString(_ctx.dashboard?.today_revenue) + " ", 1),
                        _createVNode("strong", _hoisted_11, _toDisplayString(_ctx.$t('message.TODAY')), 1)
                      ]))
                    : (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 1,
                        class: "item",
                        effect: "dark",
                        content: _ctx.dashboard?.today_revenue,
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.dashboard?.today_revenue_millify), 1)
                        ]),
                        _: 1
                      }, 8, ["content"])),
                  _hoisted_12
                ]))
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode("div", _hoisted_15, [
            _createVNode("h4", _hoisted_16, _toDisplayString(_ctx.$t('message.AVERAGE_REVENUE_OF_ORDERS')), 1),
            (_ctx.loader)
              ? (_openBlock(), _createBlock("p", _hoisted_17, [
                  _createVNode(_component_content_loader, {
                    width: "100%",
                    height: "16",
                    speed: 2,
                    primaryColor: "#ababab",
                    secondaryColor: "#cccccc"
                  }, {
                    default: _withId(() => [
                      _hoisted_18,
                      _hoisted_19
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_20, [
                  (!_ctx.dashboard.average_revenue_millify)
                    ? (_openBlock(), _createBlock("span", _hoisted_21, [
                        _createTextVNode(_toDisplayString(_ctx.dashboard?.average_revenue) + " ", 1),
                        _createVNode("strong", _hoisted_22, _toDisplayString(_ctx.$t('message.THIS_MONTH')), 1)
                      ]))
                    : (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 1,
                        class: "item",
                        effect: "dark",
                        content: _ctx.dashboard?.average_revenue,
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.dashboard?.average_revenue_millify), 1)
                        ]),
                        _: 1
                      }, 8, ["content"])),
                  _hoisted_23
                ]))
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_24, [
      _createVNode("div", _hoisted_25, [
        _createVNode("div", _hoisted_26, [
          _hoisted_27,
          _createVNode("div", _hoisted_28, [
            _createVNode("h4", _hoisted_29, _toDisplayString(`${_ctx.$t('message.TOTAL_REVENUE_ORDERS')}`), 1),
            (_ctx.loader)
              ? (_openBlock(), _createBlock("p", _hoisted_30, [
                  _createVNode(_component_content_loader, {
                    width: "100%",
                    height: "16",
                    speed: 2,
                    primaryColor: "#ababab",
                    secondaryColor: "#cccccc"
                  }, {
                    default: _withId(() => [
                      _hoisted_31,
                      _hoisted_32
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_33, [
                  (!_ctx.dashboard.monthly_revenue_millify)
                    ? (_openBlock(), _createBlock("span", _hoisted_34, [
                        _createTextVNode(_toDisplayString(_ctx.dashboard?.monthly_revenue) + " ", 1),
                        _createVNode("strong", _hoisted_35, _toDisplayString(_ctx.$t('message.THIS_MONTH')), 1)
                      ]))
                    : (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 1,
                        class: "item",
                        effect: "dark",
                        content: _ctx.dashboard?.monthly_revenue,
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.dashboard?.monthly_revenue_millify), 1)
                        ]),
                        _: 1
                      }, 8, ["content"])),
                  _hoisted_36
                ]))
          ])
        ]),
        _createVNode("div", _hoisted_37, [
          _hoisted_38,
          _createVNode("div", _hoisted_39, [
            _createVNode("h4", _hoisted_40, _toDisplayString(`${_ctx.$t('message.TOTAL_REVENUE_ORDERS')}`), 1),
            (_ctx.loader)
              ? (_openBlock(), _createBlock("p", _hoisted_41, [
                  _createVNode(_component_content_loader, {
                    width: "100%",
                    height: "16",
                    speed: 2,
                    primaryColor: "#ababab",
                    secondaryColor: "#cccccc"
                  }, {
                    default: _withId(() => [
                      _hoisted_42,
                      _hoisted_43
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_44, [
                  (!_ctx.dashboard.all_time_revenue_millify)
                    ? (_openBlock(), _createBlock("span", _hoisted_45, [
                        _createTextVNode(_toDisplayString(_ctx.dashboard?.all_time_revenue) + " ", 1),
                        _createVNode("strong", _hoisted_46, _toDisplayString(_ctx.$t('message.ALL_TIME')), 1)
                      ]))
                    : (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 1,
                        class: "item",
                        effect: "dark",
                        content: _ctx.dashboard?.all_time_revenue,
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.dashboard?.all_time_revenue_millify), 1)
                        ]),
                        _: 1
                      }, 8, ["content"])),
                  _hoisted_47
                ]))
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_48, [
      _createVNode(_component_AdvanceSearch, {
        filter: true,
        filterOption: _ctx.filterOption,
        status: _ctx.statusList,
        dateFilter: true,
        filterPlaceholder: 'message.SELECT',
        onSearch: _ctx.searchHandler,
        inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
        onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getOrders(1, true, null, null, _ctx.showDelete))),
        onExportFile: _ctx.exportFile
      }, null, 8, ["filterOption", "status", "filterPlaceholder", "onSearch", "onExportFile"]),
      _createVNode("div", _hoisted_49, [
        _createVNode("div", _hoisted_50, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('message.SHOW_DELETED_ORDERS')) + ":", 1),
          _createVNode(_component_el_switch, {
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeShowDelete())),
            modelValue: _ctx.showDelete,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDelete = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_component_Table, {
        loading: _ctx.loader,
        columns: _ctx.columns,
        rows: _ctx.orders,
        padding: 5,
        pagination: _ctx.pagination,
        onHandleCurrentChange: _ctx.handleCurrentChange,
        onSorting: _ctx.searchHandler
      }, {
        "cell-id": _withId(({row:item}) => [
          (item?.id)
            ? (_openBlock(), _createBlock("div", _hoisted_51, _toDisplayString(item?.id), 1))
            : _createCommentVNode("", true)
        ]),
        "cell-name": _withId(({row:item}) => [
          (item?.name)
            ? (_openBlock(), _createBlock("div", _hoisted_52, _toDisplayString(item?.name), 1))
            : (_openBlock(), _createBlock("div", _hoisted_53, _toDisplayString(item?.customer?.user?.name), 1)),
          (item?.order_subscription_history)
            ? (_openBlock(), _createBlock("span", _hoisted_54, _toDisplayString(_ctx.$t('message.SUBSCRIPTIONS_ORDERS')), 1))
            : _createCommentVNode("", true),
          (item?.order_subscription_history)
            ? (_openBlock(), _createBlock("br", _hoisted_55))
            : _createCommentVNode("", true),
          (item?.order_discount?.discount_id)
            ? (_openBlock(), _createBlock("span", _hoisted_56, _toDisplayString(_ctx.$t('message.DISCOUNT_ORDER')), 1))
            : _createCommentVNode("", true)
        ]),
        "cell-status": _withId(({row:item}) => [
          (item.deleted_at)
            ? (_openBlock(), _createBlock("span", _hoisted_57, _toDisplayString(_ctx.$t('message.ORDER_DELETED')), 1))
            : (_openBlock(), _createBlock("span", _hoisted_58, _toDisplayString(JSON.parse(item?.order_status?.status)[_ctx.system_locale]?.name) + " " + _toDisplayString(item?.order_status?.id == 4 ? (item?.order_payment != null ? '(Paid)' : '(Failed)') : ''), 1))
        ]),
        "cell-economic": _withId(({row:item}) => [
          (item?.economic_order_id != null)
            ? (_openBlock(), _createBlock("span", _hoisted_59, _toDisplayString(item?.economic_order_number), 1))
            : (_openBlock(), _createBlock("span", _hoisted_60, _toDisplayString(_ctx.$t('message.NOT_SENT')), 1))
        ]),
        "cell-shipment": _withId(({row:item}) => [
          (item?.order_status_id == 6)
            ? (_openBlock(), _createBlock("span", _hoisted_61, _toDisplayString(_ctx.$t('message.SENT')), 1))
            : (item?.order_status_id == 10)
              ? (_openBlock(), _createBlock("span", _hoisted_62, _toDisplayString(_ctx.$t('message.READY_FOR_SHIPMENT')), 1))
              : (item?.order_status_id == 11)
                ? (_openBlock(), _createBlock("span", _hoisted_63, _toDisplayString(_ctx.$t('message.CANCELLED')), 1))
                : (_openBlock(), _createBlock("span", _hoisted_64, _toDisplayString(_ctx.$t('message.NOT_SENT')), 1))
        ]),
        "cell-total": _withId(({row:item}) => [
          _createVNode("div", null, _toDisplayString(JSON.parse(item.order_totals)?.total?.value), 1)
        ]),
        "cell-actions": _withId(({row:item}) => [
          _createVNode("button", {
            class: "action-btn",
            type: "button",
            onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
          }, [
            _hoisted_65,
            _createVNode("div", {
              class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
            }, [
              _createVNode("div", _hoisted_66, [
                (_ctx.$can('view_order_detail'))
                  ? (_openBlock(), _createBlock("div", _hoisted_67, [
                      _createVNode("a", {
                        onClick: ($event: any) => (_ctx.handleView(item)),
                        class: "menu-link me-1"
                      }, [
                        _hoisted_68,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW')), 1)
                      ], 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (
                                    _ctx.$can('cancel_order') &&
                                        !item.deleted_at &&
                                        item?.order_status_id != 6 &&
                                        item?.order_status_id != 11 &&
                                        item?.order_discount?.discount?.discount_type != 'SUBSCRIPTION_DISCOUNT'
                                )
                  ? (_openBlock(), _createBlock("div", _hoisted_69, [
                      _createVNode("a", {
                        onClick: ($event: any) => (_ctx.handleCancel(item.id)),
                        class: "menu-link me-1"
                      }, [
                        _hoisted_70,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.CANCEL')), 1)
                      ], 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$can('delete_order') && !item.deleted_at && item?.order_discount?.discount?.discount_type != 'SUBSCRIPTION_DISCOUNT')
                  ? (_openBlock(), _createBlock("div", _hoisted_71, [
                      _createVNode("a", {
                        onClick: ($event: any) => (_ctx.handleDelete(item.id)),
                        class: "menu-link me-1"
                      }, [
                        _hoisted_72,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                      ], 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ], 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange", "onSorting"])
    ])
  ], 64))
})